import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

interface AdminRouteProps {
  children: ReactNode
}

/**
 * Route guard for admin-only pages.
 *
 * UI-level gating only — real enforcement happens in the admin Cloud
 * Functions via the `admin` custom claim (see functions/src/utils/assertAdmin.ts).
 * Rendered inside the authenticated tree where auth loading is already
 * resolved, so no separate loading state is needed.
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const { isAdmin } = useAuth()

  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default AdminRoute
